export default function Layout({ children }) {
    return (
      <div className="bg-white min-h-screen p-3 md:p-8">
        
        <div
          className="
            max-w-[1380px]
            mx-auto
            rounded-[17px]
            overflow-hidden
            
            /* DARKER, MORE VISIBLE GRADIENT */
            bg-gradient-to-b
            from-[#f5faf6]
            via-[#EEF2EA]
            to-[#E6EBE1]
  
            /* SUBTLE BORDER (IMPORTANT) */
            border border-[#E3E8DC]
  
            /* DEPTH (VERY IMPORTANT) */
            shadow-[0_20px_60px_rgba(0,0,0,0.08)]
          "
        >
          {children}
        </div>
  
      </div>
    );
  }